export const UPDATE_EQUIPMENT_SELECTED = "UPDATE_EQUIPMENT_SELECTED";
export const SET_EQUIPMENT_SELECTED = "SET_EQUIPMENT_SELECTED";

export const setEquipmentSelected = (data) => {
    return (dispatch, getState) => {
        dispatch({type: SET_EQUIPMENT_SELECTED, newData: data})
    }
}
export const updateEquipmentCount = (id, newAmount) => {
    return (dispatch, getState) => {
        newAmount = formatCounter(newAmount);
        if(newAmount !== false) {
            dispatch({type: UPDATE_EQUIPMENT_SELECTED, id, newAmount})
        }
    }
}
export const addReduceEquipmentCount = (id, isAdding) => {
    return (dispatch, getState) => {
        const newAmount = formatCounter(
            (getState().EquipmentReducer.EquipmentSelected[id] ? getState().EquipmentReducer.EquipmentSelected[id] : 0) + 
            (isAdding ? + 1 : - 1)
        );
        if(newAmount !== false) {
            dispatch({type: UPDATE_EQUIPMENT_SELECTED, id, newAmount})
        }
    }
}
const formatCounter = (newCount, min = 0, max = 99) => {
    if(isNaN(Number(newCount)) || newCount.toString().includes(".")) return false;
    if(newCount < min) newCount = min;
    if(newCount > max) newCount = max;
    return Number(newCount);
}
